"use client";
import { createSplitProps } from "../../utils/create-split-props.js";
import { composeRefs } from "../../utils/compose-refs.js";
import { ark } from "../factory.js";
import { FieldProvider } from "./use-field-context.js";
import { useField } from "./use-field.js";
import { forwardRef } from "react";
import { mergeProps } from "@zag-js/react";
import { jsx } from "react/jsx-runtime";
//#region src/components/field/field-root.tsx
var splitRootProps = createSplitProps();
var FieldRoot = forwardRef((props, ref) => {
	const [useFieldProps, localProps] = splitRootProps(props, [
		"id",
		"ids",
		"disabled",
		"invalid",
		"readOnly",
		"required",
		"target"
	]);
	const field = useField(useFieldProps);
	const mergedProps = mergeProps(field.getRootProps(), localProps);
	return /* @__PURE__ */ jsx(FieldProvider, {
		value: field,
		children: /* @__PURE__ */ jsx(ark.div, {
			...mergedProps,
			ref: composeRefs(ref, field.refs.rootRef)
		})
	});
});
FieldRoot.displayName = "FieldRoot";
//#endregion
export { FieldRoot };
